<template>
    <div v-show="can.create.desk">
        <button-primary @click="open">
            <template slot="icon"><i class="fa fa-plus"></i></template> Etage hinzufügen
        </button-primary>

        <portal to="modal" v-if="showModal">
            <modal @close="showModal = false">
                <template slot="header">
                    Neue Etage hinzufügen
                </template>

                <input-text v-model="name" class="mb-4">
                    Etage
                </input-text>


              <input-text v-model="address" class="mb-4">
                Adresse
              </input-text>

                <div class="flex justify-end" v-show="!loading">
                    <button-primary @click="create"><template slot="icon"><i class="fa fa-plus"></i></template> Etage hinzufügen</button-primary>
                </div>

                <loading v-show="loading"></loading>
            </modal>
        </portal>
    </div>
</template>

<script>
import ButtonPrimary from "./UI/ButtonPrimary";
import InputText from "./UI/InputText";
import Modal from "./Modal";
import Loading from "./UI/Loading";

export default {
    name: "FloorCreate",

    components: {Loading, Modal, InputText, ButtonPrimary},

    data: () => ({
        loading: false,
        showModal: false,
        name: '',
        address: ''
    }),

    inject: ['can'],

    methods: {
        open() {
            this.showModal = true;
        },
        create() {
            this.loading = true;
            window.axios.post('/admin/floors', {
                name: this.name,
                address: this.address
            }).then(() => {
                this.loading = false;
                this.showModal = false;
                this.$emit('created');
            }).catch(error => {
                this.loading = false;
                this.$root.$emit('error', error);
            })
        }
    }
}
</script>

<style scoped>

</style>
